var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-menu",
    {
      attrs: { "close-on-content-click": true },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function ({ on, attrs }) {
            return [
              _c(
                "v-btn",
                _vm._g(
                  _vm._b(
                    {
                      staticClass: "white--text",
                      attrs: { icon: "", "x-small": "" },
                    },
                    "v-btn",
                    attrs,
                    false
                  ),
                  on
                ),
                [_c("v-icon", [_vm._v("mdi-dots-horizontal")])],
                1
              ),
            ]
          },
        },
      ]),
    },
    [
      _c(
        "v-list",
        { attrs: { nav: "", dense: "", width: "275" } },
        [
          _c(
            "v-list-item",
            {
              on: {
                click: function ($event) {
                  return _vm.toggleEnableScreenSharing()
                },
              },
            },
            [_c("v-list-item-title", [_vm._v("Enable Screensharing")])],
            1
          ),
          _c("v-subheader", [
            _vm._v("Change Role for " + _vm._s(_vm.peer.name)),
          ]),
          _c("v-divider"),
          _c(
            "v-list-item-group",
            {
              model: {
                value: _vm.change_role,
                callback: function ($$v) {
                  _vm.change_role = $$v
                },
                expression: "change_role",
              },
            },
            [
              _c(
                "v-list-item",
                { attrs: { value: "host" } },
                [_c("v-list-item-title", [_vm._v("Host")])],
                1
              ),
              _c(
                "v-list-item",
                { attrs: { value: "coach" } },
                [_c("v-list-item-title", [_vm._v("Coach")])],
                1
              ),
              _c(
                "v-list-item",
                { attrs: { value: "guest" } },
                [_c("v-list-item-title", [_vm._v("Guest")])],
                1
              ),
              _c(
                "v-list-item",
                { attrs: { value: "waiting-room" } },
                [_c("v-list-item-title", [_vm._v("Waiting Room")])],
                1
              ),
              _c("v-divider"),
              _c(
                "v-list-item",
                { attrs: { value: "remove" } },
                [_c("v-list-item-title", [_vm._v("Remove")])],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }